// src/config/functionsBase.js
//
// Base URL for the Cloud Functions HTTPS (onRequest) endpoints that the client
// calls directly by URL. Comes from REACT_APP_FUNCTIONS_BASE when set (e.g.
// staging -> the staging project's functions host), and falls back to the
// PRODUCTION project URL when absent — so an unconfigured production build
// behaves exactly as before.
//
// Usage:
//   import { FUNCTIONS_BASE } from "../config/functionsBase";
//   fetch(`${FUNCTIONS_BASE}/sendOtp`, ...)
export const FUNCTIONS_BASE =
  process.env.REACT_APP_FUNCTIONS_BASE ||
  "https://us-central1-regulatory-portal.cloudfunctions.net";
